module.exports = __webpack_public_path__ + "img/744.cd8c5d38.jpg";